import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import React, {
  Dispatch,
  Fragment,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { getDate, getYear } from 'date-fns';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';
import { SwCircleGraph } from '../commonComponent/chart/SwCircleGraph';
import { SwStackedBarChart } from '../commonComponent/chart/SwStackedBarChart';
import { SwLineHasMultiSeriesChart } from '../commonComponent/chart/SwLineHasMultiSeriesChart';
import { SwBarLineChart } from '../commonComponent/chart/SwBarLineChart';
import { SwDatePicker } from '../commonComponent/dateSetting/SwDatePicker';

import { getMonthText, getYearDateList } from '../../common/helper';
import { useSession } from '../../hooks/session';

const INIT_HEIGHT = '35vh';

interface Props {
  type: string;
  title: string;
  count: number;
  contents: any[];
  startDate: number;
  offset?: number;
  showDateSelect?: boolean;
  selectedDate: any;
  setSelectedDate: Dispatch<SetStateAction<any>>;
  showStat?: boolean;
  labelTitle?: string[];
}

export const RwwGraphCard: React.FC<Props> = ({
  type,
  title,
  count,
  contents,
  startDate,
  offset = 0,
  showDateSelect = false,
  selectedDate,
  setSelectedDate,
  showStat,
  labelTitle,
}) => {
  const { loginVal } = useSession();
  const navigate = useNavigate();
  const [minDate, setMinDate] = useState<any>();
  const [maxDate, setMaxDate] = useState<any>();

  const onChangeToggle = (newType: string, newValue: 1 | 2) => {};

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = getYear(currentDate);
    const targetYear = loginVal.value.user.year
      ? loginVal.value.user.year
      : currentYear;
    const newDataList = getYearDateList(targetYear);

    const addDate =
      loginVal.value.user.year === currentYear
        ? getDate(currentDate) * 24 * 60 * 60 - 1
        : 31 * 24 * 60 * 60 - 1;
    setMinDate(new Date(newDataList[newDataList.length - 1] * 1000));
    setMaxDate(new Date((newDataList[0] + addDate) * 1000));
  }, []);

  return (
    <Box sx={{ m: '.5rem' }}>
      <Card key={offset} sx={{ borderColor: '#000' }}>
        <CardHeader
          sx={{
            p: '.8rem 1.5rem',
            '& .MuiCardHeader-content': {
              display: 'flex',
              alignItems: 'center',
            },
            height: '4rem',
            backgroundColor: '#fff',
          }}
          action={
            showDateSelect ? (
              <SwDatePicker
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                minDate={minDate}
                maxDate={maxDate}
              />
            ) : (
              <Typography sx={{ mt: '.3rem' }}>
                {`기준 : ${getYear(startDate * 1000)}/${getMonthText(
                  startDate * 1000
                )}`}
              </Typography>
            )
          }
          title={
            <Typography fontWeight={500} sx={{ mr: '.3rem' }}>
              {title}
            </Typography>
          }
        />
        <Divider sx={{ p: 0, m: 0 }} />
        <CardContent sx={{ height: INIT_HEIGHT, backgroundColor: '#fff' }}>
          {type === 'circle' ? (
            <SwCircleGraph
              tooltipText='조회 마지막 날 기준 활성 및 누적 사용자의 성별 분포'
              title={title}
              data={contents}
              from='medal'
              dateInfo={`기준 : ${'2024-07-16'}`}
              rangeDate={null}
              toggleType={{ type: 'medal', value: 1 }}
              onChangeToggle={onChangeToggle}
              loading={false}
            />
          ) : type === 'stacked-bar' ? (
            <SwStackedBarChart
              tooltipText='조회 마지막 날 기준 활성 및 누적 사용자의 성별 분포'
              title='성별 분포'
              data={contents}
              from='gender'
              dateInfo={`기준 : ${'2024-07-16'}`}
              rangeDate={null}
              toggleType={{ type: 'gender', value: 1 }}
              onChangeToggle={onChangeToggle}
              loading={false}
            />
          ) : type === 'multi-line' ? (
            <SwLineHasMultiSeriesChart
              tooltipText='조회 마지막 날 기준 활성 및 누적 사용자의 성별 분포'
              title='성별 분포'
              data={contents}
              from='gender'
              dateInfo={`기준 : ${'2024-07-16'}`}
              rangeDate={null}
              toggleType={{ type: 'gender', value: 1 }}
              onChangeToggle={onChangeToggle}
              loading={false}
              showStat={showStat}
              labelTitle={labelTitle}
            />
          ) : type === 'bar-line' ? (
            <SwBarLineChart
              tooltipText='조회 마지막 날 기준 활성 및 누적 사용자의 성별 분포'
              title='성별 분포'
              data={contents}
              from='gender'
              dateInfo={`기준 : ${'2024-07-16'}`}
              rangeDate={null}
              toggleType={{ type: 'gender', value: 1 }}
              onChangeToggle={onChangeToggle}
              loading={false}
              labelTitle={labelTitle}
            />
          ) : (
            ''
          )}
        </CardContent>
      </Card>
    </Box>
  );
};
